import {
  Checkbox,
  SliderRange,
  SliderRoot,
  SliderThumb,
  SliderTrack,
} from "@jammable/ui-core";
import React from "react";

const AutotuneSelector = ({ autotune, dispatchSettings, isDark }) => {
  return (
    <div
      className={`tw-flex tw-flex-col tw-items-center tw-gap-2 tw-cursor-pointer tw-p-3 tw-px-3 tw-rounded-2xl ${
        isDark ? "tw-bg-neutral-800" : "tw-bg-white"
      }`}
    >
      <div className="tw-flex tw-flex-row tw-items-center tw-gap-2 tw-justify-start tw-w-full">
        <Checkbox
          checked={autotune.enabled}
          onCheckedChange={(checked) => {
            dispatchSettings({
              type: "SET_AUTOTUNE_ENABLED",
              payload: checked,
            });
          }}
          className="data-[state=checked]:tw-bg-gradient-to-r data-[state=checked]:tw-from-blue-300 data-[state=checked]:tw-to-cyan-300 "
        />
        <div
          onClick={() => {
            dispatchSettings({
              type: "SET_AUTOTUNE_ENABLED",
              payload: !autotune.enabled,
            });
          }}
        >
          <div className="tw-text-sm tw-font-semibold tw-flex tw-items-center tw-gap-1">
            Add Autotune
            <div className="tw-text-xs tw-text-black tw-flex tw-items-center tw-justify-center tw-px-1.5 tw-py-0.5 tw-font-black tw-rounded-full tw-bg-gradient-to-r tw-from-blue-200 tw-to-cyan-200">
              BETA
            </div>
          </div>
          <div
            className={`tw-text-xs tw-text-black/40 tw-text-wrap  ${
              isDark ? "tw-text-white/60" : "tw-text-black/40"
            }`}
          >
            Tune up your vocals with a cool autotune effect!{" "}
          </div>
        </div>
      </div>
      {autotune.enabled && (
        <div className="tw-flex tw-flex-col tw-items-center tw-gap-2 tw-w-full">
          <SliderRoot
            defaultValue={[0]}
            value={[autotune.strength]}
            min={0.2}
            max={1}
            step={0.1}
            className="tw-w-full  tw-transition-all tw-mt-1.5"
            onValueChange={(e) => {
              dispatchSettings({
                type: "SET_AUTOTUNE_STRENGTH",
                payload: e[0],
              });
            }}
          >
            <SliderTrack className="tw-relative tw-h-1.5 tw-cursor-pointer tw-transition-all tw-w-full tw-grow tw-overflow-hidden tw-rounded-lg tw-bg-gradient-to-r tw-from-blue-200 tw-to-cyan-200">
              <SliderRange className="tw-absolute tw-h-full tw-bg-transparent tw-transition-all" />
            </SliderTrack>

            <SliderThumb className="tw-flex tw-h-4 tw-w-7 tw-cursor-pointer tw-items-center tw-justify-center tw-rounded-md tw-border tw-border-purple-700/50 tw-bg-cyan-400 tw-shadow-xl tw-transition-all focus-visible:tw-outline-none focus-visible:tw-ring-1 hover:tw-scale-110 focus-visible:tw-ring-ring disabled:tw-pointer-events-none disabled:tw-opacity-50"></SliderThumb>
          </SliderRoot>
          <div
            className={`tw-text-xs tw-font-black tw-tracking-widest ${
              isDark ? "tw-text-white/50" : "tw-text-cyan-600/50"
            }`}
          >
            AUTOTUNE STRENGTH{" "}
          </div>
        </div>
      )}
    </div>
  );
};

export default AutotuneSelector;
